import { Injectable } from '@angular/core';

import { Cxcenccobmulti } from "../cxcinterfaces/cxcencobmulti";
import { Cxcdetcobmulti } from "../cxcinterfaces/cxcdetcobmulti";
import { Cxctrnformapago } from '../cxcinterfaces/cxctrnformapago';
import { Cxctrnvarios } from '../cxcinterfaces/cxctrnvarios';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { Observable, of } from 'rxjs';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';
import { MessageService } from 'primeng/api';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';

@Injectable({
  providedIn: 'root'
})
export class CxcmulticobdepcliService {
  public url: string;
  public way: string;

  public cxcenccobmulti: Cxcenccobmulti[] = []
  public cxcdetcobmulti: Cxcdetcobmulti[][] = []

  public cxctrnformapagoarray: Cxctrnformapago[][] = [];
  public cxctrnvariosarray: Cxctrnvarios[][] = [];
  public dblTotalFormaPagoarray: number[] = [];

  public hmpConfiguracion: any[];

  constructor(
    private http: HttpClient,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private message: MessageService,
    private utilitariosService: UtilitariosService,
  ) { 
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');

  }
  erBusquedaVendedor(strCampo, strTabla, strValue, strParam) {

    return this.http.post(this.way + '/ventas/facturas/3rw6uc890a4nleo', {

      elementos: {
        CAMPO: strCampo,
        VALOR: strTabla,
        VALUE: strValue,
        PARAM: strParam
      },

    }, this.confIniciales.httpOptions());

  }
  desplegarDocumentos(desde, hasta): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/662fcf55b867ac000000', {
      elementos: {
        p_opcion: 'CMC',
        p_filtro: 'C.COM_CODIGO=\'01\' ',
        p_condicion: ' to_date(to_char(TRNCOBRO_fechaTrn,\'DD/MM/YYYY\'),\'DD/MM/YYYY\') between to_date(\'' + desde + '\',\'DD/MM/YYYY\') and to_date(\'' + hasta + '\',\'DD/MM/YYYY\')',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calcularTotalDeuda() {
    let totdeuda = 0
    for (let fila1 = 0; fila1 < this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
      let item: Cxcdetcobmulti = this.cxcdetcobmulti[this.init.tabs[this.init.tabindex].indice][fila1]
      totdeuda = this.utilitariosService.sumar(totdeuda,item.DETCOB_SALDOINI)//this.toScalate(item.DETCOB_SALDOINI, 2)
    }
    //totdeuda = Number(totdeuda / Math.pow(10, 2))
    this.cxcenccobmulti[this.init.tabs[this.init.tabindex].indice].TOTALDEUDA = this.utilitariosService.formatear(totdeuda,2)//Number(totdeuda).toFixed(2)
  }
  getancdepmulticli(): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/83baabb1aecb280', {
      elementos: {
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertaenccobmulti(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/257e3b7d53aec6000000000', {
      elementos: {
        p_enccob_codigo :item.ENCCOB_CODIGO,
        p_com_codigo :item.COM_CODIGO,
        p_enccob_comprobante  :item.ENCCOB_COMPROBANTE,
        p_enccob_fechaemision  :item.ENCCOB_FECHAEMISION,
        p_enccob_concepto  :item.ENCCOB_CONCEPTO,
        p_usuidentificacion  :this.usuario.identificacion,
        p_enccob_importe :item.ENCCOB_IMPORTE,
        p_ven_codigo :item.VEN_CODIGO,
        p_ENCCOB_ORIGEN:item.ENCCOB_ORIGEN
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertadetcobmulti(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/257e3b7d535dd6000000000', {
      elementos: {
       arreglodet:item
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertatrnanccobmulti(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/95f8edf54abb30000000', {
      elementos: {
       arreglodet:item
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getenccxccobmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20eebaec6617700000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetcxccobmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/20eeb5dd6617700000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getTrncobmulanc(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/10777bbbb30bb800000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  generarabonos(item,fecha): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/1075ddb56d4bc60000000000000', {
      elementos: {
        p_enccob_codigo :Number(item.ENCCOB_CODIGO),
        p_com_codigo    :'01',
        p_usuario       :this.usuario.identificacion,
        p_vendedor      :item.VEN_CODIGO,
        p_FECHA_DOC     :fecha

      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  reversarabonos(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/36efbb7c56d4bc00000000000000', {
      elementos: {
        p_enccob_codigo :Number(item.ENCCOB_CODIGO),
        p_com_codigo    :'01',
        p_usuario       :this.usuario.identificacion,
       
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarencocbmulti(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxccobmulti/3ab2b4aeadbaec0000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  gettrncobmultipro(codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/41ddeeeecc2ee0000000000000000', {
      elementos: {
        p_enccob_codigo :codigo,
        p_com_codigo :'01',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getregistro(tipo,codigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/cxcmultidepcli/20eef1d573192c00000000000000', {
      elementos: {
        p_tipo :tipo,
        p_com_codigo :'01',
        p_enccob_codigo :codigo,
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validavendedores(arreglo) {

    return this.http.post<any[]>(this.way + '/ventas/venfacimp/3eaac9aafbaed80000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
